import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './campaign-components-item.component.scss';
var CampaignComponentsItem = /** @class */ (function (_super) {
    tslib_1.__extends(CampaignComponentsItem, _super);
    function CampaignComponentsItem(element) {
        return _super.call(this, element) || this;
    }
    CampaignComponentsItem.prototype.init = function () {
    };
    CampaignComponentsItem.prototype.bindEvents = function () {
    };
    return CampaignComponentsItem;
}(Base));
export { CampaignComponentsItem };



//////////////////
// WEBPACK FOOTER
// ./components/campaign-components-item/campaign-components-item.component.ts
// module id = 175
// module chunks = 0